import i18next from 'i18next';
import { useMutation } from 'react-query';
import { GenericResponse } from '../../../interfaces/shared.interface';
import { setToast } from '../../../store/core/coreSlice';
import { store } from '../../../store/store';
import { apiRQ } from '../../api';
import { queryClient } from '../../APIProvider';

interface AbortSaleParams {
  id: string;
}

const abortSale = async ({ id }: AbortSaleParams): Promise<GenericResponse> => {
  const resp = await apiRQ.delete<GenericResponse>(`/viva/sale/${id}`);
  await queryClient?.invalidateQueries({ queryKey: ['getSale', id] });

  return resp.data;
};

export const useAbortSale = () => {
  return useMutation<GenericResponse, Error, AbortSaleParams>(abortSale, {
    onSuccess: async (data) => {
      if (data.success) {
        store.dispatch(
          setToast({
            value: { show: true, msg: i18next.t('SALE.DOC_SUCCESSFULLY_ABORTED'), position: 'top', duration: 5000 },
          }),
        );
        return;
      }

      if (data.errorCode) {
        // Error is going to be shown from middleware
        return;
      }

      let errorMsg = i18next.t('API_ERRORS.SOMETHING_WENT_WRONG');
      if (typeof data?.error === 'string') errorMsg = data.error;

      if (errorMsg) {
        store.dispatch(
          setToast({
            value: { show: true, msg: errorMsg, isError: true },
          }),
        );
      }
    },
    onError: (_error, variables: AbortSaleParams) => {
      queryClient?.invalidateQueries({ queryKey: ['getSale', variables?.id] });
    },
  });
};
